import type { AssetWithBalance, CombinedAssetWithBalance } from '@/types';
import ScrollableList from '@/ui/components/scrollable-list';
import { isCombinableAsset } from '@/ui/utils/assets';
import CombinedItem from './parts/combined-item.js';
import SingleItem from './parts/single-item.js';

export interface AssetListProps {
  assets: (AssetWithBalance | CombinedAssetWithBalance)[];
  className?: string;
}

function AssetList({ assets, className }: AssetListProps) {
  return (
    <ScrollableList
      items={assets}
      renderItem={(asset) =>
        isCombinableAsset(asset) ? (
          <CombinedItem asset={asset} />
        ) : (
          <SingleItem
            asset={asset}
            className="gap-x-4"
            dataTestId="single-token-item"
          />
        )
      }
      getItemKey={(asset) => asset.name}
      className={className}
      topBorder
    />
  );
}

export default AssetList;
